__webpack_require__.p = "//static.castlery.sg/assets/web/_next/";